import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Stack } from '@mui/material';
import appStrings from '../../common/app_strings';
import CardAtom from '../../common/atoms/card/CardAtom';
import MainImage from '../wholeme/molecules/mainImage/MainImage';
import GenericSplashPage from '../../common/molecules/GenericSplashPage';
import {
  cardTitleStyle,
  cardBodyStyle,
  cardContainerStyle,
} from './whatsNextStyles';

const {
  onboarding: { whatsNextStudent },
} = appStrings;

const WhatsNextStudent = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const history = useHistory();

  const startGoals = () => {
    history.replace('/tabs/goals');
  };

  const buildProfile = () => {
    history.replace('/wholeme/wizard');
  };

  const handleClick = (key) => {
    setSelectedCard(() => {
      const newSelectedCard = key;

      setTimeout(() => {
        if (newSelectedCard === whatsNextStudent.profile.title) {
          buildProfile();
        } else {
          startGoals();
        }
      }, 300);

      return newSelectedCard;
    });
  };

  const renderBody = () => (
    <Stack>
      <span>{whatsNextStudent.body}</span>
      <MainImage
        imageSrc="/assets/register/whats-next/two-blue-circles-three-lines.svg"
        imageAlt="blue circles"
        imageStylesOverride={{
          width: '100%',
          paddingLeft: '15%',
        }}
      />
      <Stack spacing={2.5}>
        <CardAtom
          img="/assets/register/whats-next/orange-pentagon-blue-accent.svg"
          header={whatsNextStudent.goals.title}
          body={whatsNextStudent.goals.body}
          callback={() => handleClick(whatsNextStudent.goals.title)}
          containerStyles={cardContainerStyle(selectedCard === whatsNextStudent.goals.title)}
          bodyStyles={cardBodyStyle()}
          headerStyles={cardTitleStyle()}
        />
        <CardAtom
          img="/assets/register/whats-next/blue-circle-three-lines-down.svg"
          header={whatsNextStudent.profile.title}
          body={whatsNextStudent.profile.body}
          callback={() => handleClick(whatsNextStudent.profile.title)}
          containerStyles={cardContainerStyle(selectedCard === whatsNextStudent.profile.title)}
          bodyStyles={cardBodyStyle()}
          headerStyles={cardTitleStyle()}
        />
      </Stack>
    </Stack>
  );

  return (
    <GenericSplashPage
      title={whatsNextStudent.title}
      body={renderBody()}
      backgroundImage="/assets/overlays/whats-next-student-overlay.svg"
      hideCta
    />
  );
};

export default WhatsNextStudent;
